import React, { useState, useEffect, Fragment } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Card, CircularProgress, Grid, IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, withStyles, Collapse } from '@material-ui/core';
import { blueGrey, grey } from '@material-ui/core/colors';
import empty from './notransaction.png'
import ActionBar from './ActionBar';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { format } from 'date-fns'
import TransactionStatus from './TransactionStatus';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import LoadingContainer from "../../../../components/LoadingContainer";

const ExternalTransactionTableV2 = (props) => {

    const classes = useStyles()
    const {data, total, tableFilter, onUpdateTableFilter, onSelectedItem, loading} = props

    const [open, setOpen] = useState(false)
    const [selected, setSelected] = useState(null)


    //console.log('Render this data',data)

    const onSelected = (data) => {
        console.log(data, 'mostrat detalles')
        if(selected){
            //There is something
            if(JSON.stringify(selected) === JSON.stringify(selected)){
                console.log('Cerrar')
                setSelected(null)
            }else{
                console.log('Abrir')
                setSelected(data)
            }
        }else{
            console.log('Abrir')
            setSelected(data)
        }
        
    }


    return ( 
        <div>
            <Card style={{background:'white', minHeight:300, position:'relative'}}>
                <LoadingContainer loading={loading} />
                <TableContainer className={classes.table}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {header.map(item=>{
                                    return(
                                        <TableCell className={classes.cell_header}  key={`th-${item.id}`} padding={item.padding??undefined}>
                                            <Typography className={classes.cell_text_header}>
                                                {item.label}
                                            </Typography>
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                                {data.map(item=>{
                                    
                                    const {eventId, requestDate, eventType, eventUuid, groupDescription, merchantDescription, cardholderName,cardLast8Digits,eventDateTime, amount,
                                        source,transType, category, transTypeDescription, requestAmount, status, childTransactions, provider, providerAccountNumber, accountReference} = item
        
                                    const _date = new Date(eventDateTime)
                                    const _date_date = format(_date, 'MM/dd/yy')
                                    const _date_time = format(_date, 'HH:mm:ss')
        
                                    const gpo = groupDescription ? getFirstLetters(groupDescription) : '-'
                                    const mer = merchantDescription ? getFirstLetters(merchantDescription) : '-'

                                    let open = false
                                    if(selected) open = selected.eventId === eventId

                                    const details = item?.details ?? []

                                    return(
                                        <Fragment>
                                            <TableRow key={`tr-${eventId}`}>
                                                <TableCell className={classes.cell_body}  padding='checkbox'>
                                                    {details.length ? <IconButton aria-label="expand row" size="small" onClick={() => onSelected(item)}>
                                                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                    </IconButton> : <div/>}
                                                </TableCell>
                                                <TableCell className={classes.cell_body} style={header[0].style} padding='checkbox'>
                                                    <Typography className={classes.text}>{eventId}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} style={header[1].style}>
                                                    <Grid container direction='column'>
                                                        <Grid item>{_date_date}</Grid>
                                                        <Grid item>{_date_time}</Grid>
                                                    </Grid>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} style={header[2].style}>
                                                    <Typography className={classes.text}>{category}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} style={header[3].style}>
                                                    <Typography className={classes.text}>{provider}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} style={header[4].style} >
                                                    <Typography className={classes.text}>{providerAccountNumber}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body}  >
                                                    <Typography className={classes.text} style={header[5].style}>{cardholderName}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} style={header[6].style} >
                                                    <Typography className={classes.text} noWrap >{accountReference }</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} style={header[7].style}>
                                                    <Typography className={classes.text} noWrap >{cardLast8Digits}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} style={header[8].style}>
                                                    <Typography className={classes.text} noWrap >{eventType}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} style={header[9].style}>
                                                    <Typography className={classes.text}>{`$${amount}`}</Typography>
                                                </TableCell>
                                                
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0, padding:0 }} colSpan={13}>
                                                    <Collapse in={open} timeout="auto" unmountOnExit>
                                                        <div>
                                                            <Grid container>
                                                                {details.map(el => {
                                                                    return(
                                                                        <Grid item xs={12} key={`details-${eventId}-${el.eventId}`}>
                                                                            <div className={classes.details_wrapper}>
                                                                                <Grid container>
                                                                                    <Grid item xs={3}>
                                                                                        <Typography variant='subtitle1' className={classes.details_label}>{el?.name ?? ''}</Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={9}>
                                                                                        <Typography variant='subtitle1' className={classes.details_value}>{el?.value ?? ''}</Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </div>
                                                                        </Grid>
                                                                    )
                                                                })}
                                                            </Grid>
                                                        </div>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        </Fragment>
                                        
                                    )
                                })}
                        </TableBody>
                    </Table>

                </TableContainer>
            </Card>
            



            {data && data.length ? <div className={classes.actions} style={{marginTop:16}}>
                <ActionBar total={total} tableFilter={tableFilter} onUpdateTableFilter={onUpdateTableFilter}/>
            </div> : null}
            
            
        </div>

     );
}

const useStyles = makeStyles(theme => ({
    table:{
        //width:'100%',
        //overflowX: 'auto',
        //background:'red'
        maxHeight:500,
        //minWidth:1100
    },
    table_wrapper:{
        minWidth:800,
        maxHeight:500
    },
    header:{
        display:'flex',
        wrap:'no-wrap'
    },
    cell_header:{
        background:theme.palette.primary.dark,
        //background:'white',
        //fontWeight:700,
        fontSize:16,
        boxSizing:'border-box',
        padding:4
    },
    cell_body:{
        //width:140,
        fontWeight:400,
        fontSize:16,
        boxSizing:'border-box',
        //padding:4,
        color:blueGrey[700],
        fontWeight:500,

    },
    cell_text_header:{
        color:'white',
        fontWeight:700,
        paddingLeft:8
    },
    child_title:{
        color:theme.palette.primary.dark,
        fontSize:14,
        fontWeight:600
    },
    child_body:{
        color:blueGrey[700],
        fontSize:14,
        fontWeight:400
    },
    tooltip:{
        //background:"#3f51b5",
    },
    actions:{
       //maxWidth:400
    },
    child_trans:{
        padding:'24px 0px',
        borderBottom:`1px solid ${blueGrey[200]}`
    },
    details_wrapper:{
        background:'transparent',
        borderTop:`1px solid ${grey[300]}`,
        padding:'8px 4px'

    },
    details_label:{
        fontWeight:700,
        color:blueGrey[400],
        textTransform:'uppercase'
    },
    details_value:{
        fontWeight:700,
        color:theme.palette.primary.dark,
        textTransform:'uppercase'
    },
}))

const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "#3f51b5",
      color: 'white',
      boxShadow: theme.shadows[1],
      fontSize: 14,
    },
  }))(Tooltip);

function getFirstLetters(str) {
    const firstLetters = str
      .split(' ')
      .map(word => word[0])
      .join('');
  
    return firstLetters;
  }
 
export default ExternalTransactionTableV2;

const VerticalData = ({label, data}) => {
    return(
        <div>
            <Typography variant='subtitle2'>{label}</Typography>
            <Typography variant='body2'>{data}</Typography>
        </div>
    )
}

const header = [
    {id:-1, label:'', padding:'checkbox'},
    {id:1, label:'ID', padding:'checkbox',style:{width:80}},
    {id:2, label:'Date/Time', style:{width:140}},
    {id:3, label:'Type', style:{width:200}},
    {id:4, label:'Provider', style:{width:100}},
    {id:5, label:'Account', style:{width:150}},
    {id:6, label:'Name', style:{width:200}},
    {id:7, label:'Account', style:{width:140}},
    {id:8, label:'Last 4 digits', style:{width:140}},
    {id:9, label:'Subtype', style:{width:100}},
    {id:11, label:'Amount', style:{width:140}},
]